import React from "react";
import Header from "../../components/Header/Header";
import SideNavbar from "../../components/Navbar/SideNavbar";
import StockAlertList from "../../components/StockAlert/StockAlertList";

// @@ AI-COMMENT: Stock Alert Layout Page wrapper
const StockAlert = () => {
    return (
        <div className="flex mainWrapper w-full h-full">
            <div className="sidenav-wrapper">
                <SideNavbar />
            </div>
            <div className="right-container">
                <div className="header-container">
                    <Header />
                </div>
                <div className="body-container">
                    <StockAlertList />
                </div>
            </div>
        </div>
    );
};

export default StockAlert;
